import React, { createContext, useState, useEffect, useContext, useMemo, } from 'react';
import { loadFonts } from './loadFonts';
import TextUtil from '@sas-dvr/ltjs-commons/util/TextUtil';
const FontContext = createContext({});
/**
 * Provides information about the availability of fonts. Changes in font
 * availability can be detected with useFontLoadedKey()
 */
export const FontProvider = ({ children }) => {
    const [fontAvailability, setFontAvailability] = useState({});
    useEffect(() => {
        const loadedFonts$ = loadFonts().subscribe((loadedFonts) => {
            // Order is important. This needs to be called before the set.
            TextUtil.clearFontCache();
            setFontAvailability(loadedFonts);
        });
        return () => loadedFonts$.unsubscribe();
    }, []);
    return React.createElement(FontContext.Provider, { value: fontAvailability }, children);
};
/**
 * Tests if the given font-family is loaded and available for use. The value returned
 * changes when any of the given font families loads.
 *
 * @remarks
 * This will not work correctly if any font family names include a comma or quote characters.
 *
 * @param fontFamily - a single font family, or a css font-family attribute
 *     like `'AvenirNext', Arial, Helvetica, Verdana, "Open Sans", sans-serif`
 */
export function useFontLoadedKey(fontFamily) {
    const fontAvailability = useContext(FontContext);
    return useMemo(() => {
        var _a;
        return (_a = fontFamily === null || fontFamily === void 0 ? void 0 : fontFamily.split(',').map((fontString) => {
            var _a;
            const fontFamily = fontString.trim().replace(/['"]/g, '');
            return (_a = fontAvailability[fontFamily]) !== null && _a !== void 0 ? _a : 0;
        }).reduce((sum, next) => sum + next, 0)) !== null && _a !== void 0 ? _a : 0;
    }, [fontFamily, fontAvailability]);
}
